<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="状态：">
            <el-select size="medium" v-model="searchForm.value" placeholder="请选择" clearable>
              <el-option v-for="item in PRODUCT_TYPE_LIST" :key="item.typeId" :label="item.name" :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="SKU" min-width="90"></el-table-column>
          <!-- <el-table-column prop="PRODUCT_CODE" label="商品编码" min-width="90"></el-table-column> -->
          <el-table-column prop="BRAND" label="品牌" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="品名" min-width="150"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格" min-width="150"></el-table-column>
          <el-table-column prop="UNIT" label="单位" min-width="150"></el-table-column>
          <el-table-column prop="AUDITING_STATUS" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag>{{ showStatus[scope.row.AUDITING_STATUS] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="REJECT_REASON" label="修改建议" min-width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="changeSku(scope.row)">修改SKU信息</el-button>
              <!-- <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">申请</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改SKU信息" center :visible.sync="oneButVisible" width="600px">
          <el-form size="small" :model="oneForm" ref="oneForm">
            <el-form-item label="商品名称：" :label-width="formLableWidth">
              <el-input v-model="oneForm.PRODUCT_NAME"></el-input>
            </el-form-item>
            <el-form-item label="品牌：" :label-width="formLableWidth">
              <el-input v-model="oneForm.BRAND"></el-input>
            </el-form-item>
            <el-form-item label="规格：" :label-width="formLableWidth">
              <el-input v-model="oneForm.SPECIFICATION"></el-input>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLableWidth">
              <el-input v-model="oneForm.UNIT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class=" ">
            <el-button size="small" @click="oneButVisible = false">取 消</el-button>
            <el-button size="small" @click="changeSkuSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '拒绝' }, { typeId: 1, name: '待审核' }, { typeId: 2, name: '审核通过' }],
      showStatus: ['拒绝', '待审核', '审核通过'],
      loadSearch: false,
      addFormVisible: false,
      addForm: {
        customer: '',
        project: '',
        dkId: '',
        // SEND_DAY: new Date() + 1,
      },
      exportOrderDialog: false,
      oneForm: {},
      oneButVisible: false,
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      tableData: [],
      searchForm: JSON.parse(sessionStorage.getItem('searchForm')) ? JSON.parse(sessionStorage.getItem('searchForm')) : { DAY_INTERVAL: [] },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (this.ENTRY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.ENTRY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.ENTRY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  computed: {
    ENTRY_SEARCH_DATA_CONDITION() {
      return this.$store.state.ENTRY_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    // 点击修改sku信息
    changeSku(row) {
      if (row.AUDITING_STATUS !== 0) {
        this.$message.show({ text: '审核通过，无法修改', type: 'warning' });
        return;
      }
      this.oneButVisible = true;
      this.oneForm = row;
    },
    // 修改信息提交
    changeSkuSubmit() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 36,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PRODUCT_AUDIT_ID: this.oneForm.PRODUCT_AUDIT_ID,
        PRODUCT_CODE: this.oneForm.PRODUCT_CODE,
        UNIT: this.oneForm.UNIT,
        PRODUCT_NAME: this.oneForm.PRODUCT_NAME,
        BRAND: this.oneForm.BRAND,
        SPECIFICATION: this.oneForm.SPECIFICATION,
        SUPPLIER_ID: 1,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.oneButVisible = false;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    close() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    // 筛选
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // -------------------------------------进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 35,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        // PLATFORM_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_NAME: sessionStorage.getItem('company'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.value) {
        params.AUDITING_STATUS = this.searchForm.value;
      }
      if (this.searchForm.value === 0) {
        params.AUDITING_STATUS = this.searchForm.value;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].PRODUCT_LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_QUALIFIC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/applicationSku.vue